/**
 * Created by maty on 14/02/2017.
 */

export class OrderDirection {
    get value(): boolean {
        return this._value;
    }

    static Ascending = 'asc';
    static Descending = 'desc';
    private _value: boolean;

    // boilerplate
    constructor(value: boolean) {
        return this.updateOrder(value);
    }

    updateOrder(value: boolean) {
        this._value = value;
        return this;
    }
    toString() {
        return this._value ? OrderDirection.Ascending : OrderDirection.Descending;
    }
}



// WEBPACK FOOTER //
// ./src/app/enums/order-direction.ts